// @ts-check

/**
 * Add icons to external links
 * @param {string} ariaLabel Translated text for icon aria-label
 */
export function processExternalLinks(ariaLabel) {
    let widthAndHeightIcon = 'width="25" height="24"';
    let widthAndHeightIconBig = 'width="40" height="39"';
    let classList = 'inline-block align-baseline';

    const icon = `<svg class="${classList}" aria-label="${ariaLabel}"
         ${widthAndHeightIcon} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.6328 2.5L22.1328 2.50001L22.1328 10L20.1328 10L20.1328 5.91432L10.3828 15.6643L8.96859 14.2501L18.7187 4.50001L14.6328 4.5L14.6328 2.5Z" fill="currentColor"/>
        <path d="M3.13281 4.5H10.6328V6.5H5.13281V19.5H18.1328V14H20.1328V21.5H3.13281V4.5Z" fill="currentColor"/>
    </svg>`;

    const newClassList = `${classList} text-blue-500`;
    const iconBig = icon.replace(widthAndHeightIcon, widthAndHeightIconBig).replace(classList, newClassList);;

    const links = document.links;
    for (var i = links.length; i-- > 0;) {
        let link = links[i];
        if (
            link.hostname != location.hostname &&
            link.hostname != location.hostname.replace("www.", "") &&
            !link.href.startsWith("javascript")
        ) {
            let currentIcon = icon;
            let dataElementType = link.getAttribute('data-element-type');
            const linkText = link.querySelector('[data-element-type="ext-link-item-text"]');
            let linkArrow = link.querySelector('[data-element-type="ext-link-item-arrow"]');
            const linkArrowBig = link.querySelector('[data-element-type="ext-link-item-arrow-big"]');

            if (linkArrowBig) {
                linkArrow = linkArrowBig;
                currentIcon = iconBig;
            }

            if (linkText) {
                AddExternalLinkWithFlex(linkText, currentIcon);
            } else if (linkArrow) {
                link.className += " external-link";
                linkArrow.insertAdjacentHTML("afterend", currentIcon);
                linkArrow.remove();
            } else if (dataElementType != 'ext-link-ignore') {
                AddExternalLinkWithFlex(link, currentIcon);
            }
        }
    }
}

function AddExternalLinkWithFlex(element, icon) {
    element.className += " external-link";
    element.insertAdjacentHTML("beforeend", icon);
}
